import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=3e5e0fdc&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=3e5e0fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e0fdc",
  null
  
)

export default component.exports